module.exports = __webpack_public_path__ + "static/img/nomibae_ka.b177ff3.jpg";